import { useStore } from 'framework7-vue'

import Reservations from '@/assets/classes/parking/Reservations'
import { deleteReservation, returnCard } from '@/assets/composables/endpoints'
import { showPreloader } from '@/assets/composables/preloader'
import type { ReservationRich } from '@/assets/composables/types'
import { notify, processError } from '@/assets/composables/utils'
import store from '@/js/store'

export default class Reservation extends Reservations {
  id: ReservationRich['id']
  date: ReservationRich['date']
  partOfDay: ReservationRich['partOfDay']
  timelineDate: ReservationRich['timelineDate']
  cardReturned: ReservationRich['cardReturned']
  cancelled: boolean

  constructor(res: ReservationRich) {
    super()

    this.id = res.id
    this.date = res.date
    this.partOfDay = res.partOfDay
    this.timelineDate = res.timelineDate
    this.cardReturned = res.cardReturned
    this.cancelled = res.cancelled ?? false
  }

  removeCurrentResFromList() {
    const reservations: Reservation[] = useStore('reservations').value

    const newReservations = reservations.filter((reservation) => reservation.id !== this.id)
    store.dispatch('setReservations', newReservations)
  }

  setCardReturn(isReturned: boolean) {
    this.cardReturned = isReturned
    return true
  }

  async removeReservation() {
    const closePreloader = showPreloader('Ruším rezerváciu')
    try {
      await deleteReservation(this.id, this.cardReturned)
      this.removeCurrentResFromList()
      await Reservations.fetchNewData()
      if (!this.cardReturned) {
        notify('Rezervácia bola úspešne zrušená. <b>Nezabudnite vrátiť parkovaciu kartu!</b>')
      } else {
        notify('Rezervácia bola úspešne zrušená.')
      }
    } catch (e) {
      processError(e)
      this.removeCurrentResFromList()
      await Reservations.fetchNewData()
    } finally {
      closePreloader()
    }
  }

  async returnCard() {
    const closePreloader = showPreloader('Ukladám dáta do systému')
    try {
      await returnCard(this.id)
      this.cardReturned = true
      Reservations.fetchNewData()
      notify('Karta bola úspešne vrátená.')
    } catch (e) {
      processError(e)
      Reservations.fetchNewData()
    } finally {
      closePreloader()
    }
  }
}
